import React from 'react';
import { SlArrowRight } from 'react-icons/sl';

import * as S from './styles';
import { ItemDynamicPageInPhone } from 'types/ItemDynamicPageInPhone';
import { DataFormProps } from 'components/FormDynamicPageSelected/Forms/InputsTitleWithRedirect';
import ScheduleInfoDynamicPage from 'components/ScheduleInfoDynamicPage';

interface TitleWithRedirectDefaultProps {
	item: ItemDynamicPageInPhone;
}

export default function TitleWithRedirectDefault({
	item
}: TitleWithRedirectDefaultProps) {
	const { data } = item;

	const itemTitle: DataFormProps = data;

	//se todos os dados de padding e margim está zerados eu coloco um padding no front para não ficar feio
	function allPaddingsIs0() {
		if (
			itemTitle.border_bottom === 0 &&
			itemTitle.border_left === 0 &&
			itemTitle.border_right === 0 &&
			itemTitle.border_top === 0 &&
			itemTitle.padding_bottom === 0 &&
			itemTitle.padding_left === 0 &&
			itemTitle.padding_right === 0 &&
			itemTitle.padding_top === 0
		) {
			return true;
		}
		return false;
	}

	return (
		<S.container>
			{(itemTitle.schedule_start !== '' || itemTitle.schedule_end !== '') && (
				<ScheduleInfoDynamicPage
					countdown={itemTitle.countdown}
					endDate={itemTitle.schedule_end}
					startDate={itemTitle.schedule_start}
				/>
			)}
			<S.boxInfo
				$colorText={itemTitle.color || '#000'}
				$fontWeight={itemTitle.weight === '' ? '500' : itemTitle.weight}
				$mBottom={allPaddingsIs0() ? 6 : itemTitle.border_bottom}
				$mLeft={allPaddingsIs0() ? 6 : itemTitle.border_left}
				$mRight={allPaddingsIs0() ? 6 : itemTitle.border_right}
				$mTop={allPaddingsIs0() ? 6 : itemTitle.border_top}
				$pBottom={allPaddingsIs0() ? 6 : itemTitle.padding_bottom}
				$pLeft={allPaddingsIs0() ? 6 : itemTitle.padding_left}
				$pRight={allPaddingsIs0() ? 6 : itemTitle.padding_right}
				$pTop={allPaddingsIs0() ? 6 : itemTitle.padding_top}
			>
				<p>{itemTitle.name} </p>

				{itemTitle.type !== 'none' && (
					<S.textOrIcon>
						{itemTitle.type === 'see-more' ? <p>Ver mais</p> : <SlArrowRight />}
					</S.textOrIcon>
				)}
			</S.boxInfo>
		</S.container>
	);
}
